import React from "react";
import { bool, func } from "prop-types";
import OptionsButton from "../../../../common/OptionsButton";
import SpacedOutText from "../../../../common/SpacedOutText";

const DrivingLicense = ({ value, toggleSelected }) => (
  <div className="m-md-2 mt-2">
    <SpacedOutText>Do you have a valid UK driving licence?</SpacedOutText>
    <div className="btn-group clearfix d-block">
      <OptionsButton
        items={[
          { text: "Yes", key: "driver", value: true, isActive: value === true },
          {
            text: "No",
            key: "driver",
            value: false,
            isActive: value === false,
          },
        ]}
        handleChange={toggleSelected}
      />
    </div>
  </div>
);

DrivingLicense.propTypes = {
  value: bool.isRequired,
  toggleSelected: func.isRequired,
};

export default DrivingLicense;
